module.exports = __webpack_public_path__ + "img/cloud.4f89512c.svg";